import React from "react"
import { AutoComplete, CircularProgress, Paper, FlatButton, FloatingActionButton } from "material-ui"
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import TableActionBar from "../../../components/layout/TableActionBar"
import TF from "material-ui/Table/TableFooter"
import TableFooter from "../../../components/layout/TableFooter"
import { browserHistory } from "react-router"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import AccountStore from "../../../stores/AccountStore"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import strings from "../../../localization/strings"
import debounce from "lodash.debounce"
import autobind from "class-autobind"
import * as userActions from "../../../actions/UserActions"
import * as accountActions from "../../../actions/AccountActions"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import { IHierarchyItem, IUIUser, IUserDocument } from "../../../models"
import AppStateStore from "../../../stores/AppStateStore"
import ImageLoader from "../../../components/misc/ImageLoader"
import * as api from "../../../api"
interface IProps {
    hierarchyItem: IHierarchyItem
    readonly: boolean
}
interface IState {
    employees: IUserDocument[]
    selectedEmployees: IUserDocument[],
    offset: number
    limit: number
    limitOptions: number[]
    total: number
    openAddEmployee: boolean
    employeesNames: string[]
    searchText: string
    showTable: boolean
    loading: boolean
    selectedAutoCompleteEmployee: IUserDocument
    errorTextForAutoComplete: string
}
const styles = {
    columnValue: {
        cursor: "pointer"
    },
    imageColumn: {
        width: 40,
        textAlign: "center"
    }
}

export default class HierarchyEmployees extends React.Component<IProps, IState>  {
    private onUpdateAutoCompleteDebounced
    constructor(props: IProps) {
        super(props)
        this.onUpdateAutoCompleteDebounced = debounce(text => this.onUpdateAutoComplete(text), 500)
        this.state = {
            employees: [],
            selectedEmployees: [],
            offset: 0,
            limit: 200,
            limitOptions: [10, 20, 50, 100, 200],
            total: 0,
            openAddEmployee: false,
            employeesNames: [],
            searchText: "",
            showTable: true,
            loading: true,
            selectedAutoCompleteEmployee: null,
            errorTextForAutoComplete: ""
        }
        autobind(this)
    }

    componentDidMount() {
        HierarchySettingsStore.on("global_change", this.hierarchyChangeEvent)
        this.getLinkedEmployees()
    }

    componentWillUnmount() {
        HierarchySettingsStore.removeListener("global_change", this.hierarchyChangeEvent)
    }

    getLinkedEmployees() {
        HierarchySettingsStore.getGlobalLevelItemFilterId() &&
            this.setState({ loading: true }, () => {
                userActions.getLinkedEmployees(AccountStore.getCurrentAccount().Id, HierarchySettingsStore.getGlobalLevelItemFilterId(), this.state.offset / this.state.limit, this.state.limit, this.state.searchText)
                    .then(res =>
                        this.setState({
                            total: res.TotalDocumentCount,
                            employees: res.Documents,
                            loading: false
                        })
                    )
            })
    }

    hierarchyChangeEvent() {
        this.setState({
            offset: 0,
            selectedEmployees: [],
            searchText: ""
        }, () =>
            this.getLinkedEmployees()
        )
    }

    handleDeleteEmployee() {
        //unlink employees from hierarchy
        const hierarchyitem = this.props.hierarchyItem
        hierarchyitem.LinkedEmployeeIds = hierarchyitem.LinkedEmployeeIds.filter(id => !this.state.selectedEmployees.find(employee => employee.Id === id))

        accountActions.updateAccountHierarchyItem(AuthenticationStore.getCookieAccountId(), hierarchyitem, true, null, () => {
            this.setState({
                employeesNames: [],
                offset: 0,
                searchText: "",
                selectedEmployees: []
            }, () => {
                this.getLinkedEmployees()
            })
        })
    }

    handelOnCellClick(rowNumber, colId) {
        const clickedEmployee = this.state.employees[rowNumber]
        if (colId === -1) {
            if (this.props.readonly) return
            let selectedEmployees = this.state.selectedEmployees.slice()
            if (this.state.selectedEmployees.find((item) => item.Id === clickedEmployee.Id)) {
                selectedEmployees = selectedEmployees.filter((item) => item.Id !== clickedEmployee.Id)
            }
            else {
                selectedEmployees.push(clickedEmployee)
            }
            this.setSelectedEmployees(selectedEmployees)
        }
        else if ([0, 1].includes(colId)) {
            browserHistory.push("/user-details/" + clickedEmployee.Id + "/timecards")
        }
    }

    handleOnRowSelection(result) {
        result === "all" && this.setSelectedEmployees(this.state.employees.slice())
        result === "none" && this.setSelectedEmployees([])
    }

    setSelectedEmployees(selectedEmployees) {
        this.setState({ selectedEmployees, showTable: false }, () => this.setState({ showTable: true }))
    }


    handleRequestSaveAddEmployee() {
        if (!this.state.selectedAutoCompleteEmployee) {
            this.setState({ errorTextForAutoComplete: strings.Please_choose_an_employee })
            return
        }

        const selectedEmployeeId = this.state.selectedAutoCompleteEmployee.Id
        const hierarchyLevel = this.props.hierarchyItem
        const currentAccount = AccountStore.getCurrentAccount()
        let linkedEmployeeIds = []
        linkedEmployeeIds = hierarchyLevel.LinkedEmployeeIds ? hierarchyLevel.LinkedEmployeeIds.slice() : []
        linkedEmployeeIds.find((x) => x === selectedEmployeeId) || linkedEmployeeIds.push(selectedEmployeeId)
        hierarchyLevel.LinkedEmployeeIds = linkedEmployeeIds
        accountActions.updateAccountHierarchyItem(currentAccount.Id, hierarchyLevel, true, null, () => {
            this.setState({
                employeesNames: [],
                offset: 0,
                searchText: "",
                selectedEmployees: [],
                openAddEmployee: false,
                selectedAutoCompleteEmployee: null
            }, () =>
                this.getLinkedEmployees()
            )
        })
    }

    onUpdateAutoComplete(searchText) {
        searchText &&
            api.getUIUsers(AccountStore.getCurrentAccount().Id, 0, -1, searchText).then(res => {
                const employeesNames = []
                res.data.Documents.forEach((user: IUIUser) => {
                    if (this.props.hierarchyItem.LinkedEmployeeIds && this.props.hierarchyItem.LinkedEmployeeIds.includes(user.Id)) return
                    const obj: any = {}
                    const externalId = user.ExternalId ? user.ExternalId : null
                    obj.Name = `${user.FirstName} ${user.LastName}`
                    if (externalId) obj.Name += " - " + externalId
                    obj.Id = user.Id
                    employeesNames.push(obj)
                })
                this.setState({ employeesNames })
            })
        this.setState({ errorTextForAutoComplete: "" })
    }

    render() {
        return (
            <div className="HierarchyEmployees" style={{ padding: 35, position: "relative" }}>
                {this.state.openAddEmployee &&
                    <Paper
                        style={{
                            zIndex: "100",
                            display: this.state.openAddEmployee ? "block" : "none",
                            width: 300,
                            position: "absolute",
                            top: 10,
                            right: 0,
                            marginRight: 35
                        }}
                        zDepth={3}
                    >
                        <div>
                            <h3 style={{ paddingLeft: 15, marginBottom: 0 }}>{strings.ADD_EMPLOYEE}</h3>
                            <AutoComplete
                                className="autocomplete"
                                style={{ width: "100%", padding: 0, margin: "0 20px", overflow: "hidden" }}
                                floatingLabelText={"Employee Name or " + strings.Employee_ID}
                                errorText={this.state.errorTextForAutoComplete}
                                filter={AutoComplete.caseInsensitiveFilter}
                                dataSource={this.state.employeesNames}
                                onUpdateInput={(value) => this.onUpdateAutoCompleteDebounced(value)}
                                onNewRequest={selectedAutoCompleteEmployee => this.setState({ selectedAutoCompleteEmployee })}
                                dataSourceConfig={{ text: "Name", value: "Id" }}
                                openOnFocus={true}
                                listStyle={{ overflowY: "scroll", maxHeight: 350 }}
                            />
                        </div>
                        <div style={{ float: "right" }}>
                            <FlatButton
                                label={strings.Cancel}
                                secondary
                                onTouchTap={() =>
                                    this.setState({
                                        openAddEmployee: false,
                                        searchText: "",
                                        selectedAutoCompleteEmployee: null
                                    })
                                }
                            />
                            <FlatButton
                                label={strings.Add}
                                primary
                                onTouchTap={this.handleRequestSaveAddEmployee}
                            />
                        </div>
                    </Paper>
                }
                {!this.props.readonly &&
                    <FloatingActionButton
                        secondary
                        className="fixed-add"
                        style={{ top: -110, right: 20 }}
                        onTouchTap={() => this.setState({
                            openAddEmployee: true,
                            employeesNames: []
                        })}
                    >
                        <ContentAdd />
                    </FloatingActionButton>
                }
                <TableActionBar
                    rowSelectionCount={this.state.selectedEmployees.length}
                    singleSelectedMessage={strings.Employee_Selected}
                    multipleSelectedMessage={strings.x_Employees_Selected}
                    title={null}
                    onSearch={searchText =>
                        this.setState({
                            searchText,
                            offset: 0
                        }, () =>
                            this.getLinkedEmployees()
                        )
                    }
                    searchText={this.state.searchText}
                    onDeleteClick={() =>
                        AppStateStore.setConfirmDialogContent({
                            content: strings.Are_you_sure_you_want_to_remove_current_Hierarchy_Item_from_selected_Employee,
                            confirm: () => this.handleDeleteEmployee()
                        })
                    }
                    readonly={this.props.readonly}
                    onCloseSearchClick={this.hierarchyChangeEvent}
                />
                {this.state.loading ?
                    <div className="spinner">
                        <CircularProgress />
                    </div> :
                    <div>
                        {!this.state.employees.length ?
                            <div style={{ textAlign: "center" }}>
                                <h2>{`${strings.No} ${this.props.hierarchyItem.Label} ${strings.Employees}`}</h2>
                            </div> :
                            <Table
                                multiSelectable={!this.props.readonly}
                                selectable={!this.props.readonly}
                                onRowSelection={this.handleOnRowSelection}
                                onCellClick={this.handelOnCellClick}
                            >
                                <TableHeader>
                                    <TableRow style={{ borderBottom: "1px solid rgba(0,0,0,.7)" }}>
                                        <TableHeaderColumn style={styles.imageColumn} />
                                        <TableHeaderColumn>{strings.Name}</TableHeaderColumn>
                                        <TableHeaderColumn>{strings.Default_Hierarchy}</TableHeaderColumn>
                                    </TableRow>
                                </TableHeader>
                                <TableBody showRowHover deselectOnClickaway={false}>
                                    {this.state.employees.map((row, i) => {
                                        let smallImage
                                        if (row.ProfileImageS3Url || row.ProfileImageID) {
                                            smallImage = <ImageLoader url={row.ProfileImageS3Url} fixedHeight={75} avatar={true} src={"/users/profileimage/" + row.ProfileImageID} key={`smallImg-${i}`} />
                                        }
                                        return (
                                            <TableRow key={row.Id} selected={this.state.selectedEmployees.find(item => item.Id === row.Id) ? true : false}>
                                                <TableRowColumn style={styles.imageColumn}>{smallImage}</TableRowColumn>
                                                <TableRowColumn style={styles.columnValue}>{row.FirstName + " " + row.LastName}</TableRowColumn>
                                                <TableRowColumn style={styles.columnValue}>{hierarchyHelper.getFullyQualifiedLevelNameById(row.DefaultHierarchyItemId)}</TableRowColumn>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                                <TF>
                                    <TableFooter
                                        offset={this.state.offset}
                                        limit={this.state.limit}
                                        total={this.state.total}
                                        limitOptions={this.state.limitOptions}
                                        onLimitChange={limit =>
                                            this.setState({
                                                limit,
                                                offset: 0,
                                                selectedEmployees: [],
                                            }, () =>
                                                this.getLinkedEmployees()
                                            )
                                        }
                                        onPageClick={offset =>
                                            this.setState({
                                                offset,
                                                selectedEmployees: [],
                                            }, () =>
                                                this.getLinkedEmployees()
                                            )
                                        }
                                    />
                                </TF>
                            </Table>
                        }
                    </div>
                }
            </div>
        )
    }
}